"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_LABEL_OPTIONS = exports.DEFAULT_X_AXIS_OPTIONS = exports.DEFAULT_X_TYPE = exports.DEFAULT_TOOLTIP_OPTIONS = exports.DEFAULT_TOOLTIP_SHOW_SUBTITLE = exports.DEFAULT_TOOLTIP_SHOW = exports.DEFAULT_TOOLTIP_POSITION = exports.DEFAULT_TITLE_OPTIONS = exports.DEFAULT_SUBTITLE_OPTIONS = exports.DEFAULT_FOOTER_OPTIONS = exports.DEFAULT_FOOTER_SHOW_METRIC_FOOTNOTES = exports.DEFAULT_FOOTER_SHOW = exports.DEFAULT_DROPDOWN_OPTIONS = exports.DEFAULT_DROPDOWN_TYPE = exports.DEFAULT_DROPDOWN_SORT = exports.DEFAULT_DROPDOWN_SHOW = exports.DEFAULT_DROPDOWN_ENABLED = exports.DEFAULT_BAR_OPTIONS = exports.DEFAULT_BAR_HEIGHT = exports.DEFAULT_TEXT_COLOR = exports.DEFAULT_SORT = exports.DEFAULT_SHOW_VALUE_LABEL = exports.DEFAULT_MAX_LABEL_LINES = exports.DEFAULT_FEATURED_BAR_SPACER_HEIGHT = exports.DEFAULT_LABEL_PADDING = exports.DEFAULT_LABEL_OPACITY = exports.DEFAULT_LABEL_FONT_WEIGHT = exports.DEFAULT_LABEL_FONT_SIZE = exports.DEFAULT_FEATURED_BAR_SPACER_COLOR = exports.DEFAULT_BAR_SPACING_COEFFICIENT = exports.AXIS_POSITIONS = exports.FEATURED_POSITIONS = exports.SORT_DIRECTIONS = void 0;
const lodash_1 = __importDefault(require("lodash"));
const constants_1 = require("../../utilities/constants");
const ChartWrapper_1 = require("../../components/ChartWrapper");
const Axis_1 = require("../../components/Axis");
// types
exports.SORT_DIRECTIONS = ['ascending', 'descending', false];
exports.FEATURED_POSITIONS = ['top', 'bottom'];
exports.AXIS_POSITIONS = lodash_1.default.pick(Axis_1.AXIS_POSITIONS, [Axis_1.AXIS_POSITIONS.top, Axis_1.AXIS_POSITIONS.bottom]);
// constants
exports.DEFAULT_BAR_SPACING_COEFFICIENT = 0.33;
exports.DEFAULT_FEATURED_BAR_SPACER_COLOR = '#999999';
exports.DEFAULT_LABEL_FONT_SIZE = 14;
exports.DEFAULT_LABEL_FONT_WEIGHT = 400;
exports.DEFAULT_LABEL_OPACITY = 1;
exports.DEFAULT_LABEL_PADDING = 10;
exports.DEFAULT_FEATURED_BAR_SPACER_HEIGHT = 2;
// Prop Defaults
exports.DEFAULT_MAX_LABEL_LINES = 1;
exports.DEFAULT_SHOW_VALUE_LABEL = true;
exports.DEFAULT_SORT = 'descending';
exports.DEFAULT_TEXT_COLOR = '#4D4D4D';
exports.DEFAULT_BAR_HEIGHT = 17;
exports.DEFAULT_BAR_OPTIONS = {
  color: undefined,
  height: exports.DEFAULT_BAR_HEIGHT,
  negativeColor: undefined
};
exports.DEFAULT_DROPDOWN_ENABLED = true;
exports.DEFAULT_DROPDOWN_SHOW = true;
exports.DEFAULT_DROPDOWN_SORT = true;
exports.DEFAULT_DROPDOWN_TYPE = 'items';
exports.DEFAULT_DROPDOWN_OPTIONS = {
  enabled: exports.DEFAULT_DROPDOWN_ENABLED,
  selectedItem: undefined,
  show: exports.DEFAULT_DROPDOWN_SHOW,
  sort: exports.DEFAULT_DROPDOWN_SORT,
  type: undefined
};
exports.DEFAULT_FOOTER_SHOW = true;
exports.DEFAULT_FOOTER_SHOW_METRIC_FOOTNOTES = true;
exports.DEFAULT_FOOTER_OPTIONS = {
  fontSize: constants_1.DEFAULT_FONT_SIZE,
  footnotes: undefined,
  show: exports.DEFAULT_FOOTER_SHOW,
  showMetricFootnotes: exports.DEFAULT_FOOTER_SHOW_METRIC_FOOTNOTES,
  sources: undefined
};
exports.DEFAULT_SUBTITLE_OPTIONS = {
  fontSize: ChartWrapper_1.DEFAULT_SUBTITLE_FONT_SIZE,
  text: undefined
};
exports.DEFAULT_TITLE_OPTIONS = {
  fontSize: ChartWrapper_1.DEFAULT_TITLE_FONT_SIZE,
  text: undefined
};
exports.DEFAULT_TOOLTIP_POSITION = 'below';
exports.DEFAULT_TOOLTIP_SHOW = true;
exports.DEFAULT_TOOLTIP_SHOW_SUBTITLE = true;
exports.DEFAULT_TOOLTIP_OPTIONS = {
  decimals: undefined,
  position: exports.DEFAULT_TOOLTIP_POSITION,
  show: exports.DEFAULT_TOOLTIP_SHOW,
  showSubtitle: exports.DEFAULT_TOOLTIP_SHOW_SUBTITLE
};
exports.DEFAULT_X_TYPE = 'linear';
exports.DEFAULT_X_AXIS_OPTIONS = {
  decimals: undefined,
  displayRangeMin: undefined,
  displayRangeMax: undefined,
  displayTicks: undefined,
  floatingAxis: undefined,
  fontSize: constants_1.DEFAULT_FONT_SIZE,
  type: undefined,
  showGridlines: undefined,
  ticks: undefined,
  textColor: exports.DEFAULT_TEXT_COLOR
};
exports.DEFAULT_LABEL_OPTIONS = {
  maxLines: exports.DEFAULT_MAX_LABEL_LINES,
  maxWidth: undefined,
  color: exports.DEFAULT_TEXT_COLOR,
  fontSize: constants_1.DEFAULT_FONT_SIZE,
  showValueLabels: exports.DEFAULT_SHOW_VALUE_LABEL,
  valueLabelDecimals: undefined
};